<template>
  <header id="header" role="banner">
    <div class="header-logoAreaWrap">
      <div class="header-logoArea">
        <div class="header-bangOtherLink">
          <MoleculeOtherLink type="header"/>
        </div>
        <div class="header-logo">
          <a href="/"
            ><img
              src="~/assets/images/logo.png"
              width="299"
              height="99"
              alt="保険スクエアbang! 火災保険"
          /></a>
        </div>
        <div class="header-appeal">
          サイト利用者数※
          <span><span>800万人</span>突破!</span>
        </div>
      </div>
    </div>
    <MoleculeGlobalNavPc />
    <MoleculeGlobalNavSp />
  </header>
</template>

<style lang="scss" scoped>
/*---------------------------------------
header
----------------------------------------*/
#header {
  min-height: 14vw;
  display: flex;
  align-items: center;

  .header-logoArea {
    width: 75%;
    padding: 2.1% 2.9% 2.1% 4.2%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
  }

  .header-bangOtherLink {
    display: none;
  }

  .header-logo {
    width: 40%;
  }
}

.header-appeal {
  font-size: px(10.9);
  text-align: right;
}

#header .header-appeal > span {
  display: block;
  font-size: px(26.7);
  font-weight: bold;
  line-height: 1;

  span {
    color: #f15b26;
    font-weight: bold;
  }
}


@include media(pc) {
  /*---------------------------------------
  header
  ----------------------------------------*/

  #header {
    display: block;
    min-height: auto;

    .header-logoArea {
      margin: 0 auto;
      padding: 5px 0 14px;
      width: $pcWrapWidth;
    }

    .header-bangOtherLink {
      margin: 0 0 8px;
      width: 100%;
      display: block;
    }
  }

  #header {
    .header-logo {
      width: 200px;
    }

    .header-appeal {
      width: 210px;
      font-size: px(12.9);

      > span {
        font-size: px(34.8);
      }
    }
  }
}
</style>

